<template>
  <div style="border:1px solid">
    <v-data-table :items="data" :headers="dataTableHeaders" :search="searchQuery">
      <template v-slot:top>
        <v-row class="px-3">
          <v-col>
            <v-text-field v-model="searchQuery" variant="underlined" append-inner-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn v-if="!readonly" class="mx-auto d-block" style="background-color: #f5f5f5;" @click="restoreDefaults">Restore All Defaults</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.key }}</td>
          <td>
            <div v-if="props.item.hasOwnProperty('defaultValue')">Default value: {{ props.item.defaultValue }}</div>
            <div>
              <v-text-field :readonly="readonly" variant="underlined" dense v-model="props.item.value" label="Override Value"></v-text-field>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'grid',
  props: {
    data: Array,
    readonly: Boolean
  },
  data: () => ({
    searchQuery: '',
    dataTableHeaders: [{ title: 'Key', key: 'key', width: '40%' }, { title: 'Value', key: 'value', width: '60%' }]
  }),
  methods: {
    restoreDefaults: function() {
      for (var item of this.data) {
        if (item.value) item.value = ''
      }
    }
  }
}
</script>
